t = require('app/scripts/views/internal/teacup-with-helpers')('header_invite')
memberAvatarTemplate = require './member_avatar'

module.exports = t.renderable ({ isInviter, isInternetExplorer, ghost, modelName, memberAdder, avatarHash, fullName, username, modelType, isLoggedIn, isBoard, signupUrl, isGhostEmailLoggedIn, me, email }) ->
  t.div '.invited-message', ->
    if isLoggedIn
      if ghost.email
        t.div '.personalized-invite-message', { class: t.classify({ 'logged-in': isLoggedIn }) }, ->
          helloAgainMessage =
            if isBoard
              'well-hello-again-looks-like-you-re-already-logged-in'
            else
              'well-hello-again-team-looks-like-you-re-already-logged-in'
          t.format helloAgainMessage, { email, 'ghost.email': ghost.email }

      if isGhostEmailLoggedIn # rare case when the logged in user's email matches the ghost email
        t.a '.button.js-join-model.primary', { href: '#' }, ->
          if isBoard
            t.format 'join-board'
          else
            t.format 'join-org'
      else
        t.a '.button.js-join-model.primary', { href: '#' }, ->
          if isBoard
            t.format 'yep-add-it-and-join-board'
          else
            t.format 'yep-add-it-and-join-team'
        t.a '.button.js-create-new-account.personalized-invite-right-button', { href: signupUrl }, ->
          t.format 'no-create-a-new-account'
    else
      t.a '.personalized-invite-trello-logo', { href: '/', target: '_blank', class: t.classify({ 'mod-ie': isInternetExplorer }) }
      if memberAdder
        t.span '.member', ->
          memberAvatarTemplate(memberAdder)
        t.div '.personalized-invite-message', ->
          welcomeMessage =
            if isBoard
              'welcome-to-trello-join-the-modelname-board-to-start-collaborating-with-fullname'
            else
              'welcome-to-trello-join-the-modelname-org-to-start-collaborating-with-fullname'
          t.format welcomeMessage, { fullName: memberAdder.fullName, modelName }
      else
        t.div '.personalized-invite-message', ->
          t.format 'youve-been-invited-to-collaborate-on-modelname', { modelName }

      t.a '.button.primary.personalized-invite-right-button', { href: signupUrl }, ->
        if isBoard
          t.format 'join-board'
        else
          t.format 'join-org'
